import type { EndsFdaWarningLetter } from '@ballerine/common';

import { ctw } from '@/common';

type FdaLettersTableProps = {
  letters: EndsFdaWarningLetter[];
};

const MatchPill = ({ confidence }: { confidence: string | null | undefined }) => {
  const normalized = (confidence ?? '').toLowerCase();

  if (!confidence) {
    return <span className="text-slate-400">—</span>;
  }

  const styles =
    normalized === 'confirmed'
      ? 'bg-green-100 text-green-700'
      : normalized === 'probable'
        ? 'bg-amber-100 text-amber-700'
        : 'bg-gray-100 text-gray-700';

  return (
    <span className={ctw('rounded-full px-2.5 py-0.5 text-xs font-medium uppercase', styles)}>
      {confidence}
    </span>
  );
};

export const FdaLettersTable = ({ letters }: FdaLettersTableProps) => (
  <div className="mt-6 overflow-x-auto">
    <table className="w-full border-collapse text-sm">
      <thead>
        <tr className="border-b border-gray-200 text-left text-xs uppercase tracking-wide text-slate-400">
          <th className="py-2 pr-4 font-medium">Brand / Product</th>
          <th className="py-2 pr-4 font-medium">Match</th>
          <th className="py-2 pr-4 font-medium">Action</th>
          <th className="py-2 pr-4 font-medium">Date</th>
          <th className="py-2 font-medium">Basis</th>
        </tr>
      </thead>
      <tbody>
        {letters.map((letter, index) => (
          <tr key={index} className="border-b border-gray-100 align-top last:border-b-0">
            <td className="py-3 pr-4 font-semibold text-slate-900">
              {letter.productOrBrand ?? '—'}
            </td>
            <td className="py-3 pr-4">
              <MatchPill confidence={letter.matchConfidence} />
            </td>
            <td className="py-3 pr-4 text-slate-700">{letter.actionType ?? '—'}</td>
            <td className="py-3 pr-4 text-slate-500">{letter.actionDate ?? '—'}</td>
            <td className="py-3 text-slate-500">{letter.matchBasis ?? '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
